import React from 'react'
import classNames from 'classnames'
import { BasicPageContext } from '../../context'
import style from './index.scss'

interface UtilityBox {
  className?: string
}

const UtilityBox: React.FC<UtilityBox> = ({
  children,
  className,
}): JSX.Element => (
  <BasicPageContext.Consumer>
    {isBasicPage =>
      !isBasicPage && (
        <div className={style.UtilityBoxContainer} data-test-id="utility-panel">
          <div className={classNames(style.UtilityBox, className)}>
            {children}
          </div>
        </div>
      )
    }
  </BasicPageContext.Consumer>
)

export default UtilityBox
